import { motion } from 'framer-motion';

/**
 * Animated segmented control (Public/Private, Light/Dark/System, etc.)
 */
const SegmentControl = ({ options, value, onChange, disabled = false }) => (
  <div
    className={`relative flex rounded-2xl bg-surface-100 p-1 dark:bg-surface-800/80 ${
      disabled ? 'pointer-events-none opacity-60' : ''
    }`}
  >
    {options.map((opt) => {
      const selected = value === opt.value;
      return (
        <button
          key={opt.value}
          type="button"
          disabled={disabled}
          onClick={() => onChange(opt.value)}
          className={`relative z-10 flex-1 rounded-xl px-3 py-2.5 text-sm font-semibold transition-colors ${
            selected
              ? 'text-surface-900 dark:text-white'
              : 'text-surface-500 hover:text-surface-700 dark:text-surface-400 dark:hover:text-surface-200'
          }`}
        >
          {selected && (
            <motion.span
              layoutId={`segment-${options.map((o) => o.value).join('-')}`}
              className="absolute inset-0 rounded-xl bg-white shadow-sm dark:bg-surface-700"
              transition={{ type: 'spring', stiffness: 400, damping: 32 }}
            />
          )}
          <span className="relative z-10">{opt.label}</span>
        </button>
      );
    })}
  </div>
);

export default SegmentControl;
